import React from "react";
import PropTypes from "prop-types";
import {Avatar} from "@mui/material";
import StyledTooltip from "../tooltips/StyledTooltip";
import {isString} from "underscore";
import {makeStyles} from "tss-react/mui";

const SIZES = {
  small: {avatar: 20, font: "0.8rem", fontDouble: "0.65rem"},
  medium: {avatar: 24, font: "1.05rem", fontDouble: "0.85rem"},
  default: {avatar: 40, font: "1.75rem", fontDouble: "1.4rem"},
};

export const useStyledAvatarStyles = makeStyles()(
  (theme, {size, initialsLength}) => {
    const s = SIZES[size] || SIZES.default;
    return {
      styledAvatar: {
        backgroundColor: theme.palette.neutral.main,
        color: theme.palette.neutral.contrastText,
        height: s.avatar,
        width: s.avatar,
        fontSize: initialsLength > 1 ? s.fontDouble : s.font,
        lineHeight: 1,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
      },
    };
  },
);

const getInitials = (text) => {
  const parts = text.trim().split(/\s+/);
  if (parts.length > 1) {
    return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
  }
  return parts[0].charAt(0).toUpperCase();
};

const StyledAvatar = ({text, image, size, showTooltip = true}) => {
  const initials = text && isString(text) ? getInitials(text) : "";
  const {classes} = useStyledAvatarStyles({size, initialsLength: initials.length});

  if (!text || !isString(text)) {
    return <Avatar className={classes.styledAvatar} />;
  }

  const avatar = image ?
    <Avatar src={image} className={classes.styledAvatar} /> :
    <Avatar className={classes.styledAvatar}>{initials}</Avatar>;

  if (!showTooltip) {
    return avatar;
  }

  return (
    <StyledTooltip title={text}>
      {avatar}
    </StyledTooltip>
  );
};

StyledAvatar.propTypes = {
  text: PropTypes.string,
  image: PropTypes.string,
  size: PropTypes.string,
  showTooltip: PropTypes.bool,
};

export default StyledAvatar;
